import { AnyFormControlModel } from '../dynamic-form-components/shared-models/any-form-control.model';

// check if form input should be logged to backend, based on hidden, additional.forceLog and additional.hideLog properties
export function isModelLoggable(model: AnyFormControlModel): boolean {
  const forceLog = model.additional && model.additional.forceLog === true;
  const hideLog = model.additional && model.additional.hideLog === true;

  return hideLog !== true && (model.hidden !== true || forceLog === true);
}
